import IntlProviderWrapper from './container'

export default IntlProviderWrapper
